import api from './api';
import types from './mutation-types';
import moment from 'moment';

//날짜 포맷 변경 함수
const dateFormat = ts => {
	if (!ts) return ts;
	return moment(ts).format('YYYY-MM-DD HH:mm:ss');
};

function createMessageObject(responseHeader) {
	return { ...responseHeader, type: responseHeader.code === 0 ? 'ok' : 'error' };
}
function getRowKey(rows) {
	const keys = rows.map(r => r.rowKey || 0);
	return _.max(keys) + 1;
}

export default {
	//State 변경 Action
	setState_({ commit }, { key, value }) {
		commit(types.SET_STATE, { key, value });
	},

	//공통 코드 조회: 사용 유무
	getUseYnList_({ commit, rootState }) {
		return api
			.getUseYnList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'USE_YN' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'useYnOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//조회 Action
	select_({ commit }, { currentPage, pageUnit, ...params }) {
		return api
			.select({
				useYn: params.useYn,
				params: { widgetMstFileId: params.widgetMstFileId, widgetTitle: params.widgetTitle },
				currentPage,
				pageUnit
			})
			.then(res => {
				if (res.header.code === 0) {
					const {
						result,
						pagingInfo: { currentPage, pageUnit, totalSize }
					} = res.body;

					// //날짜 포맷 변경
					const data = result.map(row => ({
						...row,
						dRegDt: dateFormat(row.regDt),
						dChgDt: dateFormat(row.chgDt)
					}));

					//테이블 페이징 조회를 위한 검색조건 저장
					commit(types.SET_STATE, { key: 'searchParams', value: params });
					//조회 데이터 저장
					commit(types.SET_STATE, { key: 'widgets', value: { currentPage, pageUnit, totalSize, data } });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//위젯 추가/수정
	save_({ dispatch, state, rootState }, params) {
		return api
			.save({ params })
			.then(res => {
				if (res.header.code === 0) {
					//위젯 정보 추가/수정 성공시 위젯 재조회
					dispatch('select_', {
						currentPage: state.widgets.currentPage,
						pageUnit: state.widgets.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//위젯 추가/수정
	delete_({ dispatch, state, rootState }, params) {
		return api
			.delete({ params })
			.then(res => {
				if (res.header.code === 0) {
					//위젯 정보 삭제 성공시 위젯 재조회
					dispatch('select_', {
						currentPage: state.widgets.currentPage,
						pageUnit: state.widgets.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	}
};
